module.exports = __webpack_public_path__ + "img/add-church-members.6162ec61.svg";